import { Box, Skeleton } from '@mui/material';

const JobMenuSkeleton = () => (
    <Box
      component="div"
      sx={{ display: 'flex', gap: 1, justifyContent: 'space-between', padding: 1 }}
    >
      <Box component="div" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Skeleton variant="rectangular" animation="wave" width={400} height={50} />
        <Skeleton variant="rectangular" animation="wave" width={250} height={50} />
      </Box>
      <Box component="div" sx={{ display: 'flex', gap: 1, alignItems: 'end' }}>
        <Skeleton variant="rectangular" animation="wave" width={200} height={50} />
        <Skeleton variant="rectangular" animation="wave" width={200} height={50} />
      </Box>
    </Box>
  );

export default JobMenuSkeleton;
